import '../i18n';
import React from 'react';
import '@core-ui/index.css';
import '../src/styles/index.css';
import ReactDOM from 'react-dom/client';
import AppHookContainer from './AppHookContainer';
import { Toaster } from '@core-ui/Components/ui/sonner';
import { ThemeProvider } from '@core-ui/providers/theme-provider.tsx';
import { initLogger } from '@lib/logger/initLogger.ts';
import { initDatadog } from '@lib/datadog/initDatadog.ts';
import ReactGA from 'react-ga4';
import { analytics } from '@constants/googleAnalytics';

const rootElement = document.getElementById('root');

if (rootElement === null) {
  throw new Error('Not found id element "root" in the DOM');
}

initLogger();
initDatadog();

const measurementId = analytics.measurementId;

ReactGA.initialize(measurementId);

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <ThemeProvider defaultTheme={'system'} storageKey={'tendril-ui-theme'}>
      <AppHookContainer />
      <Toaster />
    </ThemeProvider>
  </React.StrictMode>,
);
